import React, { useEffect, useState } from 'react';
import useNumericInput from '../../../common/hooks/useNumericInput';

interface Props{
	onChange?: (value: number) => void;
	value?: string | number;
	defaultValue?: number;
	disabled?: boolean;
	className?: string;
	containerClass?: string;
	placeholder?: string;
	min?: number;
	max?: number;
}

const NumericWithoutArrows = (props: Props): React.JSX.Element => {
	const { containerClass, ...rest } = props;
	const numbersOnly = useNumericInput();
	const [value, setValue] = useState<string | number | undefined>(props.value);

	const handleInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = (evt.currentTarget.value as unknown) as number;
		setValue(newValue);
		const n = Number(newValue);
		if (isNaN(n)) { return; }
		if (props.min !== undefined && n < props.min) { return; }
		if (props.max !== undefined && n > props.max) { return; }
		props.onChange?.(Number(newValue));
	};

	const onFocusOut = () => {
		if (props.value !== undefined) {
			setValue(props.value);
		}
	};

	useEffect(() => {
		if (props.value !== undefined) {
			setValue(props.value);
		}
	}, [props.value]);

	return (
		<div className={`gate-input numeric-input ${containerClass || ''}`}>
			<input type="text"
				{...rest}
				className={props.className || ''}
				onInput={numbersOnly}
				placeholder={props.placeholder}
				value={value}
				onChange={handleInputChange}
				onBlur={onFocusOut}
			/>
		</div>
	);
};

export default NumericWithoutArrows;
